import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Buttons, FlexContainer, ModalContext, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useGetPreviousYearInfo } from 'Containers/Filing/hooks';
import { TaxReturnTypes } from 'Containers/Result/utils';
import { PreviousYearStatus } from 'Containers/PreviousYears/types';
import CustomTransition from 'Components/CustomTransition';
import OneColLayout from 'Components/Layouts/OneColLayout';
import PreviousYearsBanner from 'Components/PreviousYearsBanner';
import { ReviewModal } from 'Components/Modal/components';
import { iconsPaths } from 'Constants/iconsPath';
import { isNative } from 'Utils/native';
import { routes } from 'Constants/routes';
import * as Styled from './styles';

const FilingXml = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { showModal } = useContext(ModalContext);
  const dispatch = useDispatch();
  const info = useSelector(routeStateSelector);
  const data = useGetPreviousYearInfo();

  const handleClick = (): void => {
    if (isNative()) {
      dispatch(history.push(routes.DASHBOARD));
      return;
    }
    showModal({
      comp: <ReviewModal />,
    });
  };

  const shouldShowPreviousYearsBanner =
    data?.stage === PreviousYearStatus.SUBMITTED &&
    data?.refundStatusType === TaxReturnTypes.TO_RETURN &&
    info?.taxReturnType === TaxReturnTypes.TO_RETURN;

  return (
    <OneColLayout>
      <CustomTransition start>
        <Styled.Container>
          <FlexContainer direction="column" justify="center" gap="dimension_08">
            <Text type="headline" size="S_L_S" color="fresh" align="center">
              {t(`ReviewDeclaration.title`)}
            </Text>
            <Text size="M_M_S" color="dark" type="paragraphs" align="center">
              {t('ReviewDeclaration.info')}
            </Text>
            <FlexContainer direction="column" align="center" justify="center">
              <img src={iconsPaths.TAX} alt="taxito" />
              {shouldShowPreviousYearsBanner ? (
                <PreviousYearsBanner tinyButtonClick={handleClick} />
              ) : (
                <Buttons.Classic
                  mode="primary"
                  size="l"
                  label={t('RevisionDeclaration.accept.button')}
                  onClick={handleClick}
                />
              )}
            </FlexContainer>
          </FlexContainer>
        </Styled.Container>
      </CustomTransition>
    </OneColLayout>
  );
};

export default FilingXml;
